/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import RotatingCard from "examples/Cards/RotatingCard";
import RotatingCardFront from "examples/Cards/RotatingCard/RotatingCardFront";
import RotatingCardBack from "examples/Cards/RotatingCard/RotatingCardBack";
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

// Images
import bgFront from "assets/images/rotating-card-bg-front.jpeg";
import bgBack from "assets/images/rotating-card-bg-back.jpeg";

function SpacetimePictureInformation() {
  return (
    <MKBox component="section" py={6} my={6}>
      <Container>
        <Grid container item xs={11} spacing={3} alignItems="center" sx={{ mx: "auto" }}>
          <Grid item xs={12} lg={4} sx={{ mx: "auto" }}>
            <RotatingCard>
              <RotatingCardFront
                image={bgFront}
                icon="touch_app"
                title={<>照片、视频</>}
                description="走路、骑车、爬山时随手拍张照，照片、视频就跟着你的轨迹走，回看时不只是路线，还有当时看到的风景和心情。"
              />
              <RotatingCardBack
                image={bgBack}
                title="照片、视频"
                description="走路、骑车、爬山时随手拍张照，照片、视频就跟着你的轨迹走，回看时不只是路线，还有当时看到的风景和心情。"
              />
            </RotatingCard>
          </Grid>
          <Grid item xs={12} lg={7} sx={{ ml: "auto" }}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  title="拍照即标记，位置自动关联"
                  description="每次拍摄照片时，App 自动获取当前位置，并将照片、视频精准锚定在地图轨迹上，形成可视化的地理记忆点"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  title="地图实时显示，所见即所记"
                  description="拍摄完成后，照片、视频图标立即出现在地图对应位置，点击即可查看图片、视频与拍摄时间，让回忆与路线无缝衔接。"
                />
              </Grid>
            </Grid>
            <Grid container spacing={3} sx={{ mt: { xs: 0, md: 6 } }}>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  title="图文轨迹，生动还原行程"
                  description="照片、视频与轨迹深度融合，回放行程时不仅能看路线，还能同步浏览沿途拍摄的实景，打造更丰富的出行回顾体验。"
                />
              </Grid>
              <Grid item xs={12} md={6}>
                <DefaultInfoCard
                  title="管理便捷，一目了然"
                  description="所有照片、视频按行程归类，在地图和列表中均可快速浏览与查找，轻松定位某张照片、视频对应的地点与时刻。"
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default SpacetimePictureInformation;
